import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {DashboardViewPageComponent} from "./dashboard/dashboard-view-page/dashboard-view-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {StockSharedModule} from "../stock/stock.shared.module";
import {CatalogueSharedModule} from "../catalogue/catalogue.shared.module";
import {SystemSharedModule} from "../system/system.shared.module";
import {CustomersSharedModule} from "../customers/customers.shared.module";
import {EmployeeSharedModule} from "../employee/employee.shared.module";
import {PosSharedModule} from "../pos/pos.shared.module";
import {ItemsContainerComponent} from "./selection-list/items-container/items-container.component";
import {DraggableItemComponent} from "./selection-list/draggable-item/draggable-item.component";
import {DraggableMemberSelectComponent} from "./selection-list/draggable-member-select/draggable-member-select.component";
import {DropContainerComponent} from "./selection-list/drop-container/drop-container.component";
import {DraggableAttributesListComponent} from "./draggable-attributes-list/draggable-attributes-list.component";
import {DimensionControlDirective} from "./selection-list/draggable-member-select/dimension-control.directive";
import {DimensionSearchControlComponent} from "./selection-list/draggable-member-select/dimension-search-control/dimension-search-control.component";
import {SelectionContainerComponent} from "./selection-list/selection-container/selection-container.component";
import {ChartOptionsComponent} from "./dashboard/dashboard-edit-page/chart-options/chart-options.component";
import {ChartOptionComponent} from "./dashboard/dashboard-edit-page/chart-options/chart-option.component";
import {DashboardChartComponent} from "./dashboard/dashboard-chart/dashboard-chart.component";
import {DashboardEditPageComponent} from "./dashboard/dashboard-edit-page/dashboard-edit-page.component";
import {BiPageSelectNavComponent} from "./bi-page/controls/bi-page-select-nav.component";
import {BIPageSearchPageComponent} from "./bi-page/bi-page-search-page/bi-page-search-page.component";
import {TopBottomCountSingleSelectSearchControlComponent} from "./controls/top-bottom-count-single-select-search-control.component";
import {ReferenceSingleSelectSearchControlComponent} from "./controls/reference-single-select-search-control.component";
import {DateTimeSharedModule} from "../datetime/datetime.shared.module";
import {PivotGridViewPageComponent} from "./pivot-grid/pivot-grid-view-page/pivot-grid-view-page.component";
import {PivotGridComponent} from "./pivot-grid/pivot-grid/pivot-grid.component";
import {PivotGridEditPageComponent} from "./pivot-grid/pivot-grid-edit-page/pivot-grid-edit-page.component";
import {ViewHeaderComponent} from "./view-header/view-header.component";
import {ViewPageHeaderComponent} from "./view-page-header/view-page-header.component";
import {FilterExtendedFieldsComponent} from "./filter-extended-fields/filter-extended-fields.component";
import {PriceComponentMultiSelectSearchControlComponent} from "./controls/price-component-multi-select-search-control.component";
import {BiServerStatusIndicatorComponent} from "./bi-server-status-indicator/bi-server-status-indicator.component";
import {SaleTypeMultiSelectSearchControlComponent} from "./controls/sale-type-multi-select-search-control.component";
import {SellableTypeMultiSelectSearchControlComponent} from "./controls/sellable-type-multi-select-search-control.component";
import {ExpenseTypeMultiSelectSearchControlComponent} from "./controls/expense-type-multi-select-search-control.component";
import {AccountSharedModule} from "../accounts/account.shared.module";
import {OrderProcessingSharedModule} from "../order-processing/order-processing.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        CustomObjectSharedModule,
        PricingSharedModule,
        StockSharedModule,
        CatalogueSharedModule,
        SystemSharedModule,
        CustomersSharedModule,
        EmployeeSharedModule,
        PosSharedModule,
        DateTimeSharedModule,
        AccountSharedModule,
        OrderProcessingSharedModule
    ],
    declarations: [
        BIPageSearchPageComponent,
        DashboardViewPageComponent,
        DashboardEditPageComponent,
        DashboardChartComponent,
        ChartOptionsComponent,
        ChartOptionComponent,

        ViewHeaderComponent,
        ViewPageHeaderComponent,

        ExpenseTypeMultiSelectSearchControlComponent,
        TopBottomCountSingleSelectSearchControlComponent,
        ReferenceSingleSelectSearchControlComponent,
        PriceComponentMultiSelectSearchControlComponent,
        SaleTypeMultiSelectSearchControlComponent,
        SellableTypeMultiSelectSearchControlComponent,

        BiPageSelectNavComponent,
        ItemsContainerComponent,
        DraggableItemComponent,
        DraggableMemberSelectComponent,
        DropContainerComponent,
        SelectionContainerComponent,

        DraggableAttributesListComponent,
        DimensionControlDirective,
        DimensionSearchControlComponent,

        PivotGridViewPageComponent,
        PivotGridComponent,

        PivotGridEditPageComponent,

        FilterExtendedFieldsComponent,
        BiServerStatusIndicatorComponent
    ]
})
export class BiModule {
}
